import { SupportedLanguage } from "../../../interfaces";
import {
  AnalyticsNavElementType,
  AnalyticsNavElementName,
  AnalyticsNavPageLink,
  AnalyticsOrigin,
} from "../analytics.types";
import { gaPushEvent } from "../base.analytics";

enum Event {
  NAV_CLICK = "nav_click",
}

export function navClickBottomBar(
  navElementName: AnalyticsNavElementName,
  origin?: AnalyticsOrigin
) {
  gaPushEvent(Event.NAV_CLICK, {
    nav_element: AnalyticsNavElementType.BOTTOM_BAR,
    nav_element_name: navElementName,
    origin,
  });
}

export function navClickChangeLanguage(
  language: SupportedLanguage,
  params?: {
    initial_language?: SupportedLanguage;
    origin?: AnalyticsOrigin;
  }
) {
  gaPushEvent(Event.NAV_CLICK, {
    nav_element: AnalyticsNavElementType.CHANGE_LANGUAGE,
    nav_element_name: language,
    initial_language: params?.initial_language,
    new_language: language,
    origin: params?.origin,
  });
}

export function navClickShareRoom(
  roomUid: string,
  format?: "link" | "qr_code" | "downloaded_qr_code"
) {
  gaPushEvent(Event.NAV_CLICK, {
    nav_element: AnalyticsNavElementType.SHARE_ROOM,
    nav_element_name: roomUid,
    format,
  });
}

export function navClickPageLink(pageLink: AnalyticsNavPageLink) {
  gaPushEvent(Event.NAV_CLICK, {
    nav_element: AnalyticsNavElementType.PAGE_LINK,
    nav_element_name: pageLink,
  });
}

export function navClickResumeGptChat(conversationId: string) {
  gaPushEvent(Event.NAV_CLICK, {
    nav_element: AnalyticsNavElementType.GPT_RESUME_CHAT,
    nav_element_name: conversationId,
  });
}
